


const requestPriceBtn = document.getElementById('inquiry_btn');
const makeInquiryModal = document.querySelector('.inquiry-modal');
const closeInquiryModal = document.getElementById('close-inquiry-modal');

requestPriceBtn?.addEventListener('click', () => {
  makeInquiryModal.classList.remove('inquiryHideModal');
});

closeInquiryModal?.addEventListener('click', () => {
  makeInquiryModal.classList.add('inquiryHideModal');
});

// Optional: close when clicking outside content
makeInquiryModal?.addEventListener('click', (e) => {
  if (e.target.classList.contains('inquiry-modal-overlay')) {
    makeInquiryModal.classList.add('inquiryHideModal');
  }
});


